export const CONNECTION_STATUS_CHECK_REQUESTED = 'referrals001:connection-status-check-requested';

export const requestConnectionStatusCheck = () => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(new Event(CONNECTION_STATUS_CHECK_REQUESTED));
};
